import React from 'react';
import { NextSeo } from 'next-seo';

import Text from 'components/Text';

import * as Styled from './styles';

export const MyOrdersPage = React.memo(() => {
  return (
    <Styled.Container>
      <NextSeo title="My Orders" />
      <Styled.Header>
        <Styled.HeaderContent>
          <Styled.HeaderTitle as="h1" variant="jumbo1">
            My Orders
          </Styled.HeaderTitle>
        </Styled.HeaderContent>
        <Styled.Triangle />
      </Styled.Header>
      <Styled.Content>
        <Styled.Card>
          <Styled.CardLeft>
            <Styled.Caption variant="caption">January 1st, 2024</Styled.Caption>
          </Styled.CardLeft>
          <Styled.CardRight>
            <Styled.PlanName variant="caption" as="h3">
              Paid with card ending 9494
            </Styled.PlanName>
            <Styled.PlanTitle variant="h2">$124.90</Styled.PlanTitle>
            <Styled.PlanDescription variant="h5">3 written testimonials - $124.99</Styled.PlanDescription>
            <Text variant="body2">Order #: 212323</Text>
          </Styled.CardRight>
        </Styled.Card>

        <Styled.Card>
          <Styled.CardLeft>
            <Styled.Caption variant="caption">January 1st, 2023</Styled.Caption>
          </Styled.CardLeft>
          <Styled.CardRight>
            <Styled.PlanName variant="caption" as="h3">
              Paid with card ending 9494
            </Styled.PlanName>
            <Styled.PlanTitle variant="h2">$124.90</Styled.PlanTitle>
            <Styled.PlanDescription variant="h5">3 written testimonials - $124.99</Styled.PlanDescription>
            <Text variant="body2">Order #: 212323</Text>
          </Styled.CardRight>
        </Styled.Card>
      </Styled.Content>
    </Styled.Container>
  );
});
